module.exports = __webpack_public_path__ + "img/tourism_cover.09409d90.webp";